import React from 'react';

const LOGO_URL = `${process.env.PUBLIC_URL}/images/logo-sem-fundo.png`;

const HeroBanner = () => {
  return (
    <section className="relative h-auto min-h-[300px] md:h-[400px] bg-[#5e151c]" data-testid="hero-banner">
      
      {/* Content - responsive flex layout (column on mobile, row on desktop) */}
      <div className="relative z-10 h-full max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center md:justify-between px-4 md:px-12 pb-12 pt-6 md:py-0">
        
        {/* Left Logo (Top Logo on Mobile) */}
        <img 
          src={LOGO_URL} 
          alt="Logo Café Colonial" 
          className="h-32 sm:h-40 md:h-48 w-auto opacity-60 mb-2 md:mb-0"
        />

        <div className="text-center px-2 md:px-4 flex-1">
          <h1 className="text-lg md:text-4xl font-bold text-white mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            <span className="text-[#DAA520]">SEJA BEM VINDO A</span>
          </h1>
          <h2 className="text-[7vw] sm:text-4xl md:text-5xl font-bold text-white whitespace-nowrap" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            CAFÉ COLONIAL CESTAS
          </h2>
          <p className="text-white/90 mt-4 text-lg italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            "A Favorita da Cidade"
          </p>
          <p className="text-[#DAA520] mt-2 text-sm">
            Desde 05/1992 • Belo Horizonte - MG
          </p>
        </div>

        {/* Right Logo */}
        <img 
          src={LOGO_URL} 
          alt="Logo Café Colonial" 
          className="hidden md:block h-32 sm:h-40 md:h-48 w-auto opacity-60"
        />

      </div>
    </section>
  );
};

export default HeroBanner;
